function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("path", {
  d: "M37 8.34734C37 5.39365 34.6149 3 31.6721 3H11.3283C8.38511 3 6 5.39365 6 8.34734V32.6527C6 35.6064 8.38511 38 11.3283 38H31.6721C34.6149 38 37 35.6064 37 32.6527V8.34734Z",
  fill: "#0066FF"
});

var _ref3 =
/*#__PURE__*/
React.createElement("path", {
  d: "M39.1954 31.6198C39.2257 36.1452 35.5671 39.8532 31.0417 39.8835L11.2448 40.0161L11.2675 43.396C11.2871 46.326 13.6842 48.6916 16.6143 48.672L42.6885 48.4972C45.6185 48.4776 47.984 46.0801 47.9644 43.1501L47.8026 19.0075C47.783 16.0775 45.3855 13.712 42.4555 13.7316L39.0756 13.7543L39.1954 31.6198Z",
  fill: "#0066FF"
});

const SvgCopy = (_ref) => {
  let {
    svgRef,
    title
  } = _ref,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 55 51",
    fill: "none",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2, _ref3);
};

const ForwardRef = React.forwardRef((props, ref) => React.createElement(SvgCopy, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/copy.a40e2993.svg";
export { ForwardRef as ReactComponent };